<template>
    <div>
        <q-card>
            <q-card-section class="row justify-center items-center">
                <q-icon
                    size="80px"
                    name="info"
                    color="primary"
                    text-color="white"
                />
                <span
                    class="col-12 text-center message"
                    style="white-space:pre-wrap;"
                    >{{ message }}</span
                >
                <br v-if="submessage" />
                <span
                    v-if="submessage"
                    class="col-12 text-center message text-grey-7"
                    style="white-space:pre-wrap;"
                    >{{ submessage }}</span
                >
            </q-card-section>
            <div class="flex justify-center">
                <slot></slot>
            </div>
            <q-card-actions align="right">
                <q-btn
                    v-if="leftBtn"
                    @click="ActionLeftBtn"
                    no-caps
                    flat
                    :label="leftBtn"
                    color="primary"
                />
                <q-btn
                    v-if="midBtn"
                    @click="ActionMidBtn"
                    no-caps
                    flat
                    :label="midBtn"
                    color="primary"
                />
                <q-btn
                    v-if="rightBtn"
                    @click="ActionRightBtn"
                    no-caps
                    flat
                    :label="rightBtn"
                    color="red"
                />
            </q-card-actions>
        </q-card>
    </div>
</template>

<script>
import { QCard, QIcon, QCardActions, QCardSection } from "quasar";
const components = {
    QCard,
    QIcon,
    QCardActions,
    QCardSection,
};
export default {
    props: ["message", "submessage", "left-btn", "right-btn", "mid-btn"],
    components: {
        ...components,
    },
    data() {
        return {};
    },
    methods: {
        ActionLeftBtn() {
            this.$emit("leftClick");
        },
        ActionMidBtn() {
            this.$emit("midClick");
        },
        ActionRightBtn() {
            this.$emit("rightClick");
        },
    },
};
</script>

<style scoped>
.message {
    position: relative;
    padding: 0.7188rem 0.9375rem 0.9375rem;
    font-size: 1rem;
    line-height: 1.5rem;
    letter-spacing: 0.0128rem;
    color: #333;
    text-align: center;
    white-space: pre-wrap !important;
}
</style>
